export default "__VITE_ASSET__DB3Lh8NG__"